(function($) {

  $.fn.toggleState = function(state) {
    var docEl = $(document.documentElement);
    $(this).on('click', function(ev) {
      ev.preventDefault();
      docEl.toggleClass(state);
    });
  };

})(jQuery);